import React, { useCallback} from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import {  StatusLayout } from '../Layout';


function StatusTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const handleSelectionChange = useCallback((name, value,e) => {
        props.handleStatusFieldChange(name, value,e);
    }, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='27EB673D-1408-4ED2-8497-DD39781DB0C5'
                layoutName='IMItemDataEntryStatusForm'
                defaultFormSchema={StatusLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleSelectionChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={props.statusFormLookupsLoad}
                handleSelectedItemChange={handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(StatusTab);
